export const REDUCER_NAME = 'tab-comments'



// WEBPACK FOOTER //
// ./src/modules/customer/state/detail/tab-comments/const.js